import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.js'

export const auditLogEntrySchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema.nullable(),
  user_id: uuidSchema.nullable(),
  action: z.string(),
  resource_type: z.string().nullable(),
  resource_id: z.string().nullable(),
  details: z.record(z.string(), z.unknown()).nullable(),
  ip_address: z.string().nullable(),
  user_agent: z.string().nullable(),
  created_at: timestampSchema,
})
export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>
